export enum FiCommentSettingType {
    NoComments = 1,
    AllowAllComments = 3,
}

export const FiCommentSettingTypes = [
    { Id: FiCommentSettingType.NoComments, TextId: 'common.no_comments' },
    { Id: FiCommentSettingType.AllowAllComments, TextId: 'common.allow_all_comments' },
];
